import { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const WriteCoverLetter: FC<TSvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.998"
      height="14.924"
      viewBox="0 0 14.998 14.924"
      {...props}
    >
      <g data-name="그룹 33845">
        <g data-name="그룹 16095">
          <g data-name="그룹 15920">
            <path
              data-name="사각형 12761"
              style={{ fill: 'none' }}
              d="M0 0h14.924v14.924H0z"
              transform="translate(.074)"
            />
          </g>
          <g data-name="그룹 16016">
            <g data-name="그룹 15988" transform="translate(0 .043)">
              <rect
                data-name="사각형 1518"
                width="6.928"
                height="1.879"
                rx=".94"
                transform="translate(8.069 11.972)"
                style={{ fill: '#01a0ff' }}
              />
              <path
                data-name="사각형 1518 - 윤곽선"
                d="M.94.9a.044.044 0 1 0 0 .089h5.048a.044.044 0 1 0 0-.089H.94m0-.9h5.048a.94.94 0 0 1 0 1.879H.94A.94.94 0 1 1 .94 0z"
                transform="translate(8.069 11.972)"
                style={{ fill: '#01a0ff' }}
              />
              <path
                data-name="패스 8448"
                d="M0 0h3.852v1.879H0z"
                transform="rotate(45 1.413 11.872)"
                style={{ fill: '#01a0ff' }}
              />
              <path
                data-name="패스 8449"
                d="M7852.717-17977.02h-3.277a.746.746 0 0 1-.747-.746v-3.406a.749.749 0 0 1 .219-.527l9.28-9.277a.746.746 0 0 1 1.055 0l3.337 3.338a.748.748 0 0 1 0 1.057l-9.34 9.342a.737.737 0 0 1-.527.219zm-2.531-1.492h2.221l8.595-8.6-2.282-2.283-8.534 8.533z"
                transform="translate(-7848.694 17991.195)"
                style={{ fill: '#01a0ff' }}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default WriteCoverLetter
